import { render } from "./IconMiniCode.vue?vue&type=template&id=e0213bd2"
import script from "./IconMiniCode.vue?vue&type=script&lang=ts"
export * from "./IconMiniCode.vue?vue&type=script&lang=ts"
script.render = render

export default script